<ngx-loading
[show]="loading"
[config]="{  backdropBorderRadius: '3px',  primaryColour: '#630f12', secondaryColour: '#630f12', tertiaryColour: '#ffcb05' }"
>
<div *ngIf="loading" style="color: white; font-size: 16px;">Loading...</div>
</ngx-loading>

<nav class="navbar navbar-expand-lg navbar-light">
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav ml-auto">
      <li class="nav-item active">
        <button mat-button [routerLink]="['/']">
            Home <mat-icon>home</mat-icon>
        </button>
      </li>
      <li class="nav-item logout">
        <button mat-button (click)="clearCache()" [routerLink]="['/login']">
            Logout <mat-icon>exit_to_app</mat-icon>
        </button>
      </li>
    </ul>
  </div>
</nav>